import styled, { css } from 'styled-components';

import { Dialog } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';

interface ConfirmModalContentProps {
  $maxWidth?: number;
}

export const ConfirmationDialogStyled = styled(Dialog)`
  width: 460px;
`;

export const ConfirmModalContent = styled(Dialog.Content)<ConfirmModalContentProps>`
  height: 150px;

  && {
    text-align: left;
    margin-top: 32px;

    ${(props) =>
      props.$maxWidth &&
      css`
        max-width: ${props.$maxWidth}px;
      `}
  }
`;

export const ConfirmModalDescription = styled.div`
  margin-top: 8px;
  color: ${Colors.Dark};
`;

export const DialogFooter = styled(Dialog.Footer)`
  && {
    justify-content: flex-end;
    padding-top: 12px;
  }
`;
